import { CommonModule } from '@angular/common';
import { Component, effect, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroBars3, heroXMark } from '@ng-icons/heroicons/outline';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { TextSizeMap } from '../../../shared/constants/text-size-map.constant';
import { ImageDirective } from '../../../shared/directives/ng-image.directive';
import { cn } from '../../../shared/utils/tw-merge';
import { NavbarComponent } from '../../modulecomponents/navbar/navbar.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  imports: [
    ImageDirective,
    RouterModule,
    NzLayoutModule,
    NzMenuModule,
    NzButtonModule,
    NzIconModule,
    NzSpaceModule,
    NavbarComponent,
    NgIcon,
    CommonModule,
  ],
  providers: [provideIcons({ heroBars3, heroXMark })],
})
export class NavigationComponent {
  TextSizeMap = TextSizeMap;
  cn = cn;

  menuOpen = signal(false);

  menuBgVisible = signal(false);

  constructor() {
    effect(() => {
      if (this.menuOpen()) {
        document.body.style.overflow = 'hidden';
        this.menuBgVisible.set(true);
      } else {
        document.body.style.overflow = '';
        setTimeout(() => this.menuBgVisible.set(false), 200);
      }
    });
  }

  toggleMenu() {
    this.menuOpen.update((v) => !v);
  }
}
